
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import Shop from "./pages/Shop";
import Article from "./pages/Article";
import ProductDetail from "./pages/ProductDetail";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import DeodorantQuiz from "./pages/DeodorantQuiz";
import Contact from "./pages/Contact";
import AskAIButton from "./components/AskAIButton";
import { useEffect } from "react";
import { useMobileBrowser } from "./hooks/use-mobile-browser";
import { sslHandler } from "./utils/sslHandler";

// Create query client with enhanced cross-browser compatible settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry SSL/certificate errors
        if (error?.message?.includes('SSL') || error?.message?.includes('certificate')) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Simplified Security Enhancer
const SecurityEnhancer = () => {
  const { isMobile, browserType, isInstagramWebView, isFacebookWebView } = useMobileBrowser();

  useEffect(() => {
    console.log(`Security enhancer initialized for ${browserType} browser`);
    
    // Re-enhance links when component mounts
    sslHandler.enhanceLinks();
    
    // Special handling for social media webviews
    if (isInstagramWebView || isFacebookWebView) {
      console.log("Social media webview detected - applying specialized handling");
      document.body.classList.add('social-webview');
    }
    
  }, [browserType, isInstagramWebView, isFacebookWebView]);

  return null;
};

const App = () => {
  const { browserType } = useMobileBrowser();
  const showAIButton = browserType !== 'edge';

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <SecurityEnhancer />
          {showAIButton && <AskAIButton />}
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/article/:slug" element={<Article />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/quiz" element={<DeodorantQuiz />} />
            <Route path="/deodorant-quiz" element={<DeodorantQuiz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
